<template>
  <div class="preview-scroll">
    <el-row>
      <el-col :offset="17" class="ignore-button" :span="7">
        <el-button-group >
          <el-tooltip
              effect="dark"
              content="Xuất excel về máy"
              placement="top-start"
          >
            <el-button
                type="success"
                @click="handleDownloadExcel"
                icon="el-icon-download"
            ></el-button>
          </el-tooltip>
            <el-button
                type="success"
                @click="printDuplicateContent"
                icon="el-icon-files"
            ></el-button>
          <el-tooltip
              effect="dark"
              content="Cài đặt"
              placement="top-start"
          >
            <el-button
                type="success"
                @click="settingFontSize"
                icon="el-icon-setting"
            ></el-button>
          </el-tooltip>
        </el-button-group>
      </el-col>
    </el-row>

    <div
        v-for="(data, index) in listKidsPrint"
        :key="index"
        :class="['pdf_container', { 'pdf_container--last': index === listKidsPrint.length - 1 }]"
        :style="customStyle"
    >
      <br/>
      <div style="width: 96%; margin: auto">
        <el-row class="header_kids" v-if="data.logoSchool !== null" type="flex" :gutter="10">
          <el-col :span="4">
            <div class="logo-fixed-wrapper">
              <img class="logo-fixed-img" :src="data.logoSchool" alt=""/>
            </div>
          </el-col>
          <el-col :span="16" style="text-align: center; line-height: 1.5">
            <p>
              <b style="">{{ data.nameSchool }}</b>
              <br/>
              <span>{{ data.addressSchool }} </span>

              <br/>
              <b>PHIẾU THU HỌC PHÍ THÁNG {{ dataSearch.month }}/{{dataSearch.createdYear}} - ĐỢT {{ dataSearch.collectionTurn }}</b>
            </p>
          </el-col>
          <el-col :span="4">
            <div class="qr-fixed-wrapper">
              <img class="qr-fixed-img" :src="data.imgQrBank" alt=""/>
            </div>
          </el-col>
        </el-row>
        <el-row class="header_kids" v-else>
          <el-col :offset="6" :span="12" style="text-align: center; line-height: 1.5">
            <p>
              <b style="">{{ data.nameSchool }}</b>
              <br />
              <span>{{ data.addressSchool }} </span>

              <br />
              <b>PHIẾU THU HỌC PHÍ THÁNG {{ dataSearch.month }}/{{dataSearch.createdYear}} - ĐỢT {{ dataSearch.collectionTurn }}</b>
            </p>
          </el-col>
          <el-col :offset="2" :span="4">
            <div class="qr-fixed-wrapper">
              <img class="qr-fixed-img" :src="data.imgQrBank" alt=""/>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="print__left"
          ><span><b>Họ tên:</b> {{ data.nameKid }} ({{data.kidCode}})</span></el-col
          >
          <el-col :span="12" class="print__right"
          ><span><b>Mã:</b> ..........</span></el-col
          >
          <el-col :span="12" class="print__left"
          ><span><b>Lớp:</b> {{ data.nameClass }}</span></el-col
          >
          <el-col :span="12" class="print__right"
          ><span><b>Số:</b> ..........</span></el-col
          >
          <el-col :span="12"  class="print__left"
          ><span><b>SĐT:</b> {{ data.phoneKid }}</span></el-col
          >
          <el-col :span="12" class="print__right"
          ><span><b>Quyển số:</b> ..........</span></el-col
          >
        </el-row>

        <el-row style="margin-top: 6px">
          <print-null-table v-if="configData.statusPrint !== true" :table-data="data" :statusSumPrice="configData.statusSumPrice"/>
          <print-not-null-table v-else :table-data="data" :statusSumPrice="configData.statusSumPrice"/>
        </el-row>

        <el-row  style="margin-top: 5px">
            <span><b>Ghi chú hóa đơn:</b> <span style="white-space: pre-line;font-style: italic;">{{ data.noteExcel2 }}</span></span>
            <i> {{ data.expired }}</i>
        </el-row>
        <el-row style="margin-top: 5px">
          <el-col class="print__left" span="8">
            <span><b>STK:</b> {{ data.accountNumber }}</span>
          </el-col>
          <el-col span="16">
            <span><b>Chủ TK:</b> {{ data.fullName }}</span>
          </el-col>
          <el-col span="7">
            <span><b>Ngân hàng:</b> {{ data.bankName }}</span>
          </el-col>
        </el-row>

        <el-row   class="footer_field">
          <el-col v-if="configData.statusShowDateTime" :offset="6">
            <span><i>{{currentTime}}, ngày {{day}} tháng {{month}} năm {{year}}</i></span>
          </el-col>
          <el-col :span="12"><b>Người nộp tiền</b></el-col>
          <el-col :span="12"><b>Người lập phiếu</b></el-col>
          <el-col  :offset="12" :span="12" style="margin-top: 70px"><b>{{data.userName}}</b></el-col>
        </el-row>

      </div>
    </div>
    <div>
      <el-dialog
          title="Thiết lập cỡ chữ"
          :visible.sync="dialogVisible"
          :close-on-click-modal="false"
          width="300px"
          >
        <el-row>
          <el-col :span="8" style="margin-top: 8px">
            <span>Chọn cỡ chữ</span>
          </el-col>
          <el-col :span="4">
            <el-select v-model="customFontSize" placeholder="Chọn cỡ chữ" style="width: 70px" size="smail">
              <el-option
                  v-for="item in listFontSize"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" @click="dialogVisible = false">Đóng</el-button>
         </span>
      </el-dialog>
    </div>
  </div>

</template>
<script>
import {mapState} from "vuex";
import {v4} from "uuid";
import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";
import {handleAndDownloadExcel} from "@/utils/dowloadExcel";
import PrintNotNullTable from "@/components/FinanceVer2/ByClass/PrintPage/PrintNotNullTable.vue";
import PrintNullTable from "@/components/FinanceVer2/ByClass/PrintPage/PrintNullTable.vue";
import SchoolConfigService from "@/services/SchoolService/SchoolConfigService";
import printModeMixin from "@/global/mixin/printMode.mixin";

export default {
  name: "SplitPDF",
  mixins: [printModeMixin],
  components: {PrintNullTable, PrintNotNullTable},
  data() {
    return {
      listKidsPrint: [],
      configData: {
        statusPrint: undefined,
        statusShowDateTime: undefined,
        statusSumPrice: false
      },
      disableTooltip:false,
      listBillParams: {
        date: "",
        idKidList: "",
        collectionTurn: "",
        guiId: "",
      },
      dataBillFirst:[],
      currentTime: '',
      day: '',
      month: '',
      year: '',
      customFontSize: 15,
      dialogVisible: false,
      printModeClass: "split-pdf-print",
      listFontSize: [7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,29,29,30],
    };
  },
  async created() {
    this.listKidsPrint = []
    // Lấy ngày hiện tại
    let now = new Date();
    // Lấy giờ-phút hiện tại
    let hours = now.getHours();
    let minutes = now.getMinutes();
    this.currentTime = `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;

// Lấy ngày-tháng-năm hiện tại
    let dayNow = now.getDate();
    this.day = `${dayNow < 10 ? '0' + dayNow : dayNow}`
    let monthNow = now.getMonth() + 1; // Tháng bắt đầu từ 0
    this.month = `${monthNow < 3 ? '0' + monthNow : monthNow}`
    this.year = now.getFullYear();
    await SchoolConfigService.getConfigPrintOrder().then((res) => {
      if (res && res.data) {
        this.configData.statusPrint = res.data.statusPrint;
        this.configData.statusShowDateTime = res.data.statusShowDateTime;
        this.configData.statusSumPrice = res.data.statusSumPrice;
      }
    })
    this.listKidsPrint =this.dataBillPreview.flatMap(student=>[student,student])
    // cái này xử lí nếu bấm nút f5
    if(this.dataBillPreview.length===0&&Object.keys(this.dataSearch).length === 0){
      this.$router.push('/finance/v2')
    }
  },
  computed: {
    ...mapState("finance2Module", [
      "dataBillPreview",
      "dataSearch",
      "idKidList",
    ]),
    customStyle() {
      return {
        '--custom-font-size': this.customFontSize + 'px'
      };
    }
  },
  // xoá dữ liệu khi back lại, f5 trang
  beforeRouteLeave(to, from, next){
    this.cleanupPrintMode(this.printModeClass);
    this.$store.commit("finance2Module/renew_bill_preview");
    next(); // Xử lí tiếp tục điều hướng
  },
  beforeDestroy() {
    this.handleAfterPrint(this.printModeClass);
  },
  methods: {
    printDuplicateContent() {
      this.triggerPrintMode(this.printModeClass);
    },
    settingFontSize(){
        this.dialogVisible = true
    },
    handleDownloadExcel() {
      const guiId = v4();
      this.listBillParams.date = this.$funcCommon.formatMY(this.dataSearch.createdYear, this.dataSearch.month);
      this.listBillParams.idKidList = this.idKidList;
      this.listBillParams.collectionTurn = this.dataSearch.collectionTurn;
      this.listBillParams.guiId = guiId;
      // bắt đầu gọi export
      financeKidsV2Service
          .exportBillToExcel(this.listBillParams)
          .then((res) => {
            // chạy neeus k conf processing
            if (res.data.message === "processing") {
              this.$notify.info({
                title: "Thông báo",
                message: "Dữ liệu đang được xử lý !",
              });
            }
            // Call the function again after 5 seconds
            const checkProcess = setInterval(() => {
              financeKidsV2Service
                  .exportBillToExcel(this.listBillParams)
                  .then((res) => {
                    if(res.data.message === "fail"){
                      clearInterval(checkProcess)
                      this.$notify.error({
                        title: "Thông báo",
                        message: "Lỗi không xuất được data !",
                      });
                      return;
                    }
                    // chạy neeus k conf processing
                    if (res.data.message === "processing") {
                      this.$notify.info({
                        title: "Thông báo",
                        message: "Dữ liệu đang được xử lý !",
                      });
                    }
                    else {
                      this.$notify.success({
                        title: "Thông báo",
                        message: "Dữ liệu xuất thành công",
                      });
                      const excelFilename = res.data.message.split('complete_')[1]; // Provide a desired filename for the downloaded file
                      clearInterval(checkProcess);
                      return financeKidsV2Service
                          .downloadBillToExcel(this.listBillParams.guiId)
                          .then((res) => {
                            const excelData = res.data;
                            handleAndDownloadExcel(excelData, excelFilename);
                          });
                    }
                  })
                  .catch((err) => {
                    return Promise.reject(err);
                  });
            }, 3000);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
    },
  },



};
</script>
<style lang="scss">
/* CSS in riêng cho 2 liên hóa đơn trên 1 trang A4 ngang */
@media print {
  /* Ép trình duyệt in màu nền và ảnh nền */
  html.split-pdf-print * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  html.split-pdf-print,
  html.split-pdf-print body,
  html.split-pdf-print body #app,
  html.split-pdf-print body .preview-scroll {
    height: auto !important;
    overflow: visible !important;
  }

  html.split-pdf-print body .preview-scroll {
    display: block !important;
    width: 100% !important;
  }

  html.split-pdf-print body .pdf_container {
    display: inline-block !important;
    width: 50% !important;
    min-height: 148.5mm !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 6mm 8mm !important;
    box-sizing: border-box !important;
    box-shadow: none !important;
    vertical-align: top !important;
    break-inside: avoid !important;
    page-break-inside: avoid !important;
    overflow: visible !important;
    font-size: var(--custom-font-size, 15px) !important;
  }

  /* Quy tắc ngắt trang: sau mỗi cặp hóa đơn (hóa đơn thứ 2, 4, 6...) */
  html.split-pdf-print body .pdf_container:nth-child(2n) {
    break-after: page !important;
    page-break-after: always !important;
    display: inline-block !important;
    width: 50% !important;
  }

  html.split-pdf-print body .pdf_container--last {
    break-after: auto !important;
    page-break-after: auto !important;
  }
}
</style>
<style scoped>
.footer_field {
  text-align: center;
}

.header_kids {
  margin-top: 20px;
  height: 13%;
}

.logo-fixed-wrapper,
.qr-fixed-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  margin: 0 auto;
  flex: 0 0 100px;
}

.qr-fixed-wrapper {
  padding: 0;
}

/* Kich thuoc vuong co dinh cho logo va QR */
.logo-fixed-img,
.qr-fixed-img {
  display: block;
  width: 100% !important;
  height: 100% !important;
  min-width: 100px;
  min-height: 100px;
  max-width: 100px;
  max-height: 100px;
  aspect-ratio: 1 / 1;
  object-fit: contain;
}

.pdf_container {
  outline: 1px solid transparent;
  margin: auto;
  background-color: white;
  font-family: "Times New Roman",serif;
  font-size: var(--custom-font-size, 15px);
  width: 40%;
  height: 100%;
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
}

.print__left {
  white-space: nowrap;
  text-align: left;
}

.print__right {
  text-align: right;
}

.preview-scroll {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

@page {
  size: A4 landscape; /* Set the paper size to A4 in landscape mode */
  margin: 0;
}

@media print {
  .preview-scroll {
    height: auto;
    overflow: visible;
  }
  .ignore-button {
    display: none !important;
  }
  .print__left {
    float: left;
  }
  .print__right {
    float: right;
  }


  .header_kids {
    margin-top: 0;
    height: 13%;
  }

  .bold-text {
    font-weight: bold;
  }
  .el-row {
    page-break-inside: avoid;
  }
}
</style>
